import type { MediaAsset } from '@ghostscreen/contracts';
import type { ContentLibraryGroup } from './buildContentLibrary';
import { ContentLibraryGrid } from './ContentLibraryGrid';

type ContentLibrarySectionsProps = {
  groups: ContentLibraryGroup[];
  tileSize: number;
  usedMediaIds: ReadonlySet<string>;
  onOpen: (asset: MediaAsset) => void;
};

/**
 * Photos-style date sections — Today / This week / Earlier.
 */
export function ContentLibrarySections({
  groups,
  tileSize,
  usedMediaIds,
  onOpen,
}: ContentLibrarySectionsProps) {
  return (
    <div className="flex flex-col gap-[22px]">
      {groups.map((group) => (
        <section key={group.id} className="flex flex-col gap-2.5">
          <span className="flex items-baseline gap-2.5">
            <span
              className="text-[15px] font-extrabold"
              style={{ color: 'var(--gs-ink)' }}
            >
              {group.label}
            </span>
            <span className="text-[13px]" style={{ color: 'var(--gs-muted)' }}>
              {group.countLabel}
            </span>
          </span>
          <ContentLibraryGrid
            assets={group.items}
            tileSize={tileSize}
            usedMediaIds={usedMediaIds}
            onOpen={onOpen}
          />
        </section>
      ))}
    </div>
  );
}
